import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { NewEmailForm } from "../../../emails/-components/NewEmailForm";
import type { EmailType, EmailLanguage } from "@/lib/mma/types.gen";

export const Route = createFileRoute("/_dashboard/organisations/$orgId/emails/new-email")({
  component: NewEmailComponent,
  validateSearch: (search: Record<string, unknown>) => {
    const type = search.type ? (search.type as EmailType) : undefined;
    const language = search.language ? (search.language as EmailLanguage) : undefined;
    return { type, language };
  },
});

function NewEmailComponent() {
  const { orgId } = Route.useParams();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate({
      to: "/organisations/$orgId/emails",
      params: { orgId },
      search: { type: undefined, language: undefined },
    });
  };

  return (
    <NewEmailForm
      scope="organisation"
      orgId={orgId}
      returnTo={`/organisations/${orgId}/emails`}
      onCancel={handleCancel}
    />
  );
}
